import { Component, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { BusyIndicatorService } from 'src/services/busy-indicator.service';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-gnb',
  templateUrl: './gnb.component.html',
  styleUrls: ['./gnb.component.scss']
})
export class GnbComponent implements OnInit {  

  constructor(
    private router: Router,
    private busyIndicator: BusyIndicatorService,
    private AuthService: AuthService,
    private logger: NGXLogger) {
    console.log(this.router.events);
  }


  ngOnInit(): void {
    this.router.events
      .subscribe((event: Event) => {
        switch (true) {
          case event instanceof NavigationStart: {
            this.busyIndicator.update(true);
            break;
          }

          case event instanceof NavigationEnd:
          case event instanceof NavigationCancel:
          case event instanceof NavigationError: {
            this.busyIndicator.update(false);
            break;
          }
          default: {
            break;
          }
        }
      })


    //관리자 이외 ADMIN 메뉴 안 보이도록

    //let email: string = this.AuthService.currentUserValue.email;

    //let type:string = this.AuthService.currentUserValue.type;
    //if (type != null) {

    //  //const contents = document.getElementsByName('expand');

    //  //if (type == "Y") {

    //  //  contents.forEach(content => {
    //  //    if (content.style.display == 'none')
    //  //      content.style.display = 'block';
    //  //    else
    //  //      content.style.display = 'none';
    //  //  });
    //  //} else {
    //  if (type == "N")  document.getElementById('adminArea').style.display = 'none';
      
    //}

  }

  ngAfterViewInit(): void {
    let type: string = this.AuthService.currentUserValue.type;
    if (type !=  'Y') document.getElementById('adminArea').style.display = 'none';
  }

  expand(name: string) {

    console.log('expand');
    const contents = document.getElementsByName(name);
    
     

    //document.getElementById('adminArea').style.display = 'block';
        

    contents.forEach(content => {
      if (content.style.display == 'none')
        content.style.display = 'block';
      else
        content.style.display = 'none';
    });
       
  }
  
}
